import { render, staticRenderFns } from "./tan_car_wz.vue?vue&type=template&id=c3210714&scoped=true"
import script from "./tan_car_wz.vue?vue&type=script&lang=js"
export * from "./tan_car_wz.vue?vue&type=script&lang=js"
import style0 from "./tan_car_wz.vue?vue&type=style&index=0&id=c3210714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3210714",
  null
  
)

export default component.exports